// extracted by mini-css-extract-plugin
module.exports = {"cookieBanner":"CookieBanner_cookieBanner__2LlAj","buttons":"CookieBanner_buttons__1csr7"};